export enum SidePanelType {
	None = 0,
	Note = 1,
	Agreement = 2,
	Settings = 3,
	MarketView = 4,
	MoneyReceipt = 5, // واریز
	Payment = 6, // برداشت
	Conditional = 7, // هشدار درون برنامه‌ای
	Menu = 8,
	BrokerChange = 9,
	Feedback = 10,
	AboutUs = 11,
	Messages = 12,
	layoutList = 13,
	AccountActivity = 14,
	WalletCard = 15,
	Funds = 16,
	ChangeHistory = 17,
	Search = 18,
	Children = 19,
	EasyChart = 20,
	Option = 21,
	AiMarketAssistant = 22
}

export const SidePanelTypeObject = {
	settings: SidePanelType.Settings,
	'wallet-card': SidePanelType.WalletCard,
	funds: SidePanelType.Funds,
	messages: SidePanelType.Messages,
	menu: SidePanelType.Menu,
	conditional: SidePanelType.Conditional,
	agreement: SidePanelType.Agreement,
	marketView: SidePanelType.MarketView,
	aiMarketAssistant: SidePanelType.AiMarketAssistant
};
